module.exports = __webpack_public_path__ + "static/img/nodata.94d738e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/nodata.png
// module id = 595
// module chunks = 3